/**
 * 柱状图
 * 
 * 发生x次离床过久报警
 */
export default function getEchartsOptionBarA1(xAxis_data, series_data, expansion_data, markArea_range) {
	let option = {
		grid: {
			x: 15,
			y: 15,
			x2: 15,
			y2: 10,
			containLabel: true
		},
		tooltip: {
			trigger: "axis",
			backgroundColor: 'rgba(255, 255, 255, 0.95)',
			borderColor: "rgba(216, 226, 248, 1)",
			borderWidth: 1,
			borderRadius: 4,
			textStyle: {
				color: "#8394B9",
			},
			confine: true,
			formatter: function (value) {
				let tempArr = expansion_data[value[0].dataIndex] || []
				if (!tempArr || tempArr.length == 0) {
					return
				}
				let startTime = parseInt(value[0].name);
				let endTime = startTime + 9;
				let startHours = Math.floor(startTime / 60);
				let startHoursStr = startHours < 10 ? '0' + startHours : startHours;
				let startMinutes = startTime - (startHours * 60);
				let startMinutesStr = startMinutes < 10 ? '0' + startMinutes : startMinutes;
				let endHours = Math.floor(endTime / 60);
				let endHoursStr = endHours < 10 ? '0' + endHours : endHours;
				let endMinutes = endTime - (endHours * 60);
				let endMinutesStr = endMinutes < 10 ? '0' + endMinutes : endMinutes;
				let topStr1 = startHoursStr + ':' + startMinutesStr + '～' + endHoursStr + ':' + endMinutesStr + ' 发生';
				let topStr2 = value[0].value;
				let bottomStr = '';
				for (let i = 0; i < tempArr.length; i++) {
					let item = tempArr[i];
					if (i == 0) {
						bottomStr += item;
					} else {
						bottomStr = bottomStr + '、' + item;
					}
				}
				
				let divStr = "<div style='display: flex; flex-direction: column;'><div style='display: flex;'><div style='font-size: 14px; font-family: PingFangSC, PingFang SC; font-weight: 400; color: #8394B9; line-height: 17px;'>" + topStr1 + "</div><div style='font-size: 14px; font-family: PingFangSC, PingFang SC; font-weight: 400; color: rgba(255, 113, 134, 1); line-height: 17px;'>" + topStr2 + "</div><div style='font-size: 14px; font-family: PingFangSC, PingFang SC; font-weight: 400; color: #8394B9; line-height: 17px;'>次</div></div><div style='display: flex; margin-top: 2px;'><div style='width: 6px; height: 6px; background: #4A7CE8; border-radius: 3px; margin-top: 6px;'></div><div style='flex: 1; font-size: 14px; font-family: PingFangSC, PingFang SC; font-weight: 400; color: #8394B9; line-height: 17px; margin-left: 4px; max-width: 285px; white-space: wrap;'>" + bottomStr + "</div></div></div>"
				return divStr;
				return "<div style='display: flex; flex-direction: column;'><div style='display: flex;'><div style='font-size: 14px; font-family: PingFangSC, PingFang SC; font-weight: 400; color: #8394B9; line-height: 17px;'>04:01～04:10 发生</div><div style='font-size: 14px; font-family: PingFangSC, PingFang SC; font-weight: 400; color: rgba(255, 113, 134, 1); line-height: 17px;'>9</div><div style='font-size: 14px; font-family: PingFangSC, PingFang SC; font-weight: 400; color: #8394B9; line-height: 17px;'>次</div></div><div style='display: flex; margin-top: 2px;'><div style='width: 6px; height: 6px; background: #4A7CE8; border-radius: 3px; margin-top: 6px;'></div><div style='flex: 1; font-size: 14px; font-family: PingFangSC, PingFang SC; font-weight: 400; color: #8394B9; line-height: 17px; margin-left: 4px; width: 264px; white-space: wrap;'>04:01～04:01、04:02～04:02、04:03～04:03、04:04～04:04、04:05～04:05、04:06～04:06、04:07～04:07、04:08～04:08、04:09～04:12</div></div></div>";
			},
		},
		xAxis: {
			data: xAxis_data,
			axisTick: {
				show: true,
			},
			axisLabel: {
				textStyle: {
					color: "rgba(165, 169, 188, 1)", //坐标的字体颜色
					fontSize: 10
				},
				formatter: function(value) {
					if (value % 120 == 0) {
						let message = '';
						let tempTime = value;
						let hours = Math.floor(tempTime / 60);
						let minutes = tempTime - (hours * 60);
						message += (hours < 10 ? '0' + hours : hours) + ":" + (minutes < 10 ? '0' + minutes : minutes);
						return message;
					} else {
						return null;
					}
				},
				interval: 5,
			},
			axisLine: {
				show: true,
				lineStyle: {
					color: "rgba(144, 148, 166, 0.1)",
					type: "solid",
					width: 1
				},
			},
			axisTick: {
				lineStyle: {
					color: "rgba(165, 169, 188, 1)",
					type: "solid",
					width: 1
				},
			},
			interval: 60
		},
		yAxis: {
			type: 'value',
			axisLine: {
				show: false,
			},
			axisLabel: { // 坐标轴刻度标签的相关设置。
				textStyle: {
					color: "rgba(165, 169, 188, 1)",
					fontSize: 10
				},
				formatter: function (val) {
					if (val == 0) {
						return null
					}
					return val + '次';
				},
			},
			splitNumber: 3,
			minInterval: 1,
			splitLine: {
				lineStyle: {
					color: "rgba(144, 148, 166, 0.1)",
					type: "solid",
					width: 1
				},
			},
		},
		series: [
			{
				data: series_data,
				type: 'bar',
				itemStyle: {
					borderRadius: [2, 2, 2, 2], // 左上、右上、右下、左下分别设置不同的圆角大小
					color: 'rgba(74, 124, 232, 1)'
				},
			}
		]
	};
	return option;
}